import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetNewsCommentsReviewsUseCase extends UseCase {
  constructor({config, repository, newsCommentsRequestValueObjectFactory}) {
    super()

    this._config = config
    this._repository = repository
    this._newsCommentsRequestValueObjectFactory = newsCommentsRequestValueObjectFactory
  }

  @tracer({metric: 'GetNewsCommentsReviewsUseCase#execute'})
  @inlineError
  async execute({articleId, items, pageNumber}) {
    const requestVO = this._newsCommentsRequestValueObjectFactory({
      articleId,
      items,
      pageNumber
    })
    const [getNewsCommentsError, getNewsCommentsResponse] = await this._repository.getNewsComments(requestVO)

    return getNewsCommentsError ? Promise.reject(getNewsCommentsError) : getNewsCommentsResponse.toJSON()
  }
}
